<template>
  <div>
    <v-divider></v-divider>
    <div class="px-3">
      <h2 class="checkout-h2 pt-3">Valor a Pagar</h2>
      <h4 class="grey--text mt-1">
        Divida este pagamento com outras pessoas fazendo um pagamento parcial.
        <a @click="dialog = true">Mais informações</a>
      </h4>
      <v-text-field
        class="custom-text mt-3"
        outline
        v-money="money"
        required
        ref="textmoney"
        v-model="partialValueModel"
        label="Valor"
        :error="!!textError"
        @keydown="changePartialValue"
        @blur="setTextError"
      >
      </v-text-field>
      <div class="mb-3">
        <span class="red--text" style="font-weight: bold">
          {{ textError }}
        </span>
      </div>
    </div>
    <v-divider></v-divider>
    <v-layout row justify-center>
      <v-dialog v-model="dialog">
        <description-partial @closeDialog="dialog = false" />
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import DescriptionPartial from '../Alerts/DescriptionPartial.vue';
import { VMoney } from 'v-money';
import { mapGetters } from 'vuex';
export default {
  components: { DescriptionPartial },
  directives: { money: VMoney },
  data() {
    return {
      interval: null,
      seconds: 3,
      dialog: false,
      textError: '',
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false,
      },
    };
  },
  computed: {
    ...mapGetters([
      'cartProducts',
      'partialValue',
      'totalAmount',
      'orderPdvData',
      'pdv',
      'paymentData',
    ]),
    formatedPartialValue() {
      if (this.partialValue && typeof this.partialValue === 'string')
        return Number(
          this.partialValue
            .replace('R$ ', '')
            .replaceAll('.', '')
            .replace(',', '.')
        );
      else if (this.partialValue && typeof this.partialValue === 'number')
        return this.partialValue;
      else return 0;
    },
    productsTotal() {
      if (this.isCardPaymentOption) {
        return this.$store.getters.totalAmount;
      }

      let total = 0;
      let somador = 0;
      this.cartProducts.forEach(p => {
        p.forEach(v => {
          somador += (v.valor + v.valor_conveniencia) * v.quantidade;
        });
      });
      total = somador;
      return total;
    },
    totalModeOrder() {
      if (this.productsOrder) {
        let total = 0;
        this.productsOrder.forEach(p => {
          total +=
            p.quantidade * (Number(p.valor) + Number(p.valor_conveniencia));
        });
        return total;
      } else return 0;
    },
    partialValueModel: {
      get() {
        return this.partialValue * 100;
      },
      set(val) {
        this.$store.commit(
          'SET_PARTIAL_VALUE',
          Number(
            val
              .replace('R$ ', '')
              .replaceAll('.', '')
              .replace(',', '.')
          )
        );
      },
    },
  },
  methods: {
    changePartialValue() {
      const { eventID } = this.$store.getters;
      this.$store.dispatch('setPaymentOption', null);
      this.seconds = 1;
      this.interval = setInterval(() => {
        this.seconds--;
        if (this.seconds === 0) {
          clearInterval(this.interval);
          this.$store.dispatch('fetchPaymentOptions', {
            eventID,
            pdv: this.pdv,
            total: this.formatedPartialValue,
            disableLoading: true,
            commissioner: this.$route.name === 'commissioner',
            partialPayment: true,
          });
        }
      }, 500);
    },
    setTextError() {
      const { split_payment } = this.paymentData;

      let multiplier = 0.2;

      if (split_payment) multiplier = split_payment / 100;

      if (this.$route.name === 'commissioner') {
        let percent = Number(this.orderPdvData.valor_pendente) * multiplier;
        if (
          this.orderPdvData &&
          this.orderPdvData.valor_pendente &&
          this.formatedPartialValue > Number(this.orderPdvData.valor_pendente)
        )
          this.textError = 'Valor parcial maior que valor total';
        else if (
          percent > this.formatedPartialValue &&
          !this.orderPdvData.valor_pago
        )
          this.textError = `Necessário pagamento de no mínimo ${
            split_payment ? split_payment : '20'
          }% do valor do pedido`;
        else this.textError = '';
      } else {
        let percent = this.productsTotal * multiplier;
        if (
          this.productsTotal &&
          this.formatedPartialValue > this.productsTotal
        )
          this.textError = 'Valor parcial maior que valor total';
        else if (percent > this.formatedPartialValue)
          this.textError = `Necessário pagamento de no mínimo ${
            split_payment ? split_payment : '20'
          }% do valor do pedido`;
        else this.textError = '';
      }
      this.$store.commit('SET_PARTIAL_ERROR', !!this.textError);
    },
  },
};
</script>
